export const qaLabelTrackingLink = {
    contactDetailsDiv: 'tracking-link-page--contact-details-div',
    contactPhoneNumber: 'tracking-link-page--contact-details-phone',
    predefinedDeliveryText: 'tracking-link-page--delivery-text',
    siteText: 'tracking-link-page--site-text',
    map: 'tracking-link-page--map',
    phoneBtn: 'tracking-link-page--phone-btn',
    smsBtn: 'tracking-link-page--sms-btn',
    orderDetailsTitle: 'tracking-link-page--order-details-title',
    jobName: 'tracking-link-page--job-name',
    jobExternal: 'tracking-link-page--job-external',
    pickupAddress: 'tracking-link-page--pickup-address',
    pickupAddressTitle: 'tracking-link-page--pickup-address-title',
    userContactTitle: 'tracking-link-page--user-contact-title',
    userContact: 'tracking-link-page--user-contact',
    deliveryAddressTitle: 'tracking-link-page--delivery-address-title',
    deliveryAddress: 'tracking-link-page--delivery-address',
    instructionsTitle: 'tracking-link-page--instructions-title',
    instructions: 'tracking-link-page--instructions',
    tipTitle: 'tracking-link-page--tip-title',
    tip: 'tracking-link-page--tip',
    quantityTitle: 'tracking-link-page--quantity-title',
    quantity: 'tracking-link-page--quantity',
    totalTitle: 'tracking-link-page--total-title',
    total: 'tracking-link-page--total',
    orderProgressTitle: 'tracking-link-page--order-progress-title',
    orderProgressBar: 'tracking-link-page--order-progress-bar',
    orderProgressDropdownButton: 'tracking-link-page--order-progress-dropdown-button',
    orderProgressItemText: 'tracking-link-page--order-progress-list-item-text',
    orderProgressItemTime: 'tracking-link-page--order-progress-list-item-time',
    orderProgressListDiv: 'tracking-link-page--order-progress-list',
    etaTitle: 'tracking-link-page--eta-title',
    etaText: 'tracking-link-page--eta-text',
    etaMessage: 'tracking-link-page--eta-message',
    etaSubtitle: 'tracking-link-page--eta-subtitle',
    statusTitle: 'tracking-link-page--status-title',
    statusSubtitle: 'tracking-link-page--status-subtitle',
    cancelledTitle: 'tracking-link-page--cancelled-title',
    deliveredTitle: 'tracking-link-page--delivered-title',
    headerLogo: 'tracking-link-page--header-img',
    ratingTitle: 'tracking-link-page--rating-title',
    ratingCommentLabel: 'tracking-link-page--rating--comment-label',
    ratingTextarea: 'tracking-link-page--rating--textarea',
    ratingSubmitBtn: 'tracking-link-page--rating--submit-btn',
    ratingStars: 'tracking-link-page--rating--stars-div'
};
